export default __webpack_public_path__ + "static/media/one_green_mob.397fa54c.svg";